let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = Promise.all([load("aCh9P"), load("bxxT5"), load("eZTkw")]).then(() => parcelRequire('lNgkk'));